<template>
    <div>
        <form
            class="hero-block-inner__form form-account form-account--reset"
            @submit.prevent="submit"
        >
            <div class="form-account__title">Password reset</div>
            <div class="form-account__row form-row">
                <v-text-field
                    v-model.lazy="model.email"
                    v-validate="'required|email'"
                    name="email"
                    :label="$t('fields.email')"
                    type="email"
                    :data-vv-as="$t('fields.email')"
                    :error-messages="errors.collect('email')"
                    persistent-placeholder
                    outlined
                ></v-text-field>
            </div>
            <div class="form-account__links form-row">
                <router-link
                    class="form-row__link form-row__link--button"
                    to="/account/sign-in"
                >
                    Back to Sign in page
                </router-link>
                <button
                    type="submit"
                    class="form-row__submit form-row__submit--parted"
                >
                    Reset
                </button>
            </div>
        </form>
        <div class="result">
            <div class="result__image">
                <img
                    src="../assets/images/letter.svg"
                    alt="An email with recovery link has been sent to your email"
                />
            </div>
            <div class="result__title">
                An email with recovery link has been sent to your email
            </div>
        </div>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';

    export default {
        $_veeValidate: {
            validator: 'new',
        },
        data() {
            return {
                model: {
                    email: null,
                },
                visibility: false,
            };
        },
        computed: {
            ...mapGetters('auth', ['isLoading']),
        },
        mounted() {
            const dict = {
                custom: {
                    email: {
                        email: 'Invalid Email',
                        required: 'Email field is required',
                    },
                },
            };

            this.$validator.localize('en', dict);
        },
        methods: {
            ...mapActions('auth', ['passwordReset']),

            /**
             * Send email with password recovery link
             */
            async submit() {
                const validation = await this.$validator.validateAll();

                if (!validation) return;

                this.passwordReset(this.model.email);
            },
        },
    };
</script>

<style scoped lang="stylus">
    @import '../assets/styles/pages/account';
</style>
